import http from '@axios'

const resource = 'api/v1/employee/import'
export default {
  import(file) {
    return http.post(`${resource}`, file, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
}
